import {
    DEFAULT_AXNUI_CONTENT,
    DEFAULT_AXNUI_LAYOUT,
    DEFAULT_AXNUI_THEME,
    DEFAULT_DCUI_CONTENT,
    DEFAULT_DCUI_THEME
} from "@iddataweb/idw-common-ui/constants";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import {
    AXNUI_CONTENT_PROPERTY_TYPE_ID,
    AXNUI_LAYOUT_PROPERTY_TYPE_ID,
    AXNUI_THEME_PROPERTY_TYPE_ID,
    DCUI_CONTENT_PROPERTY_TYPE_ID,
    DCUI_THEME_PROPERTY_TYPE_ID
} from "@constants/verification-service-details-constants";
import { FormattedIdwProfile, IdwProfile } from "@idw-types/data/idw-profile";
import { AvailableProperty, AxnCompany } from "@idw-types/data/reference-data/axn";
import { formatAppliedProfileProfileProperties } from "./applied-profile-profile-properties-formatter";

export const formatAppliedProfileProfile = (
    profile: IdwProfile,
    axnCompanies: Array<AxnCompany>,
    availableProperties: Array<AvailableProperty>,
    shouldPopulateMissingProperties: boolean
): FormattedIdwProfile => {

    const profileProperties = [...profile.profileProperties];

    if (shouldPopulateMissingProperties) {
        // if axnui theme property not present - add it
        const axnuiThemingProperty = profile.profileProperties.find(pp => pp.availablePropertyID === AXNUI_THEME_PROPERTY_TYPE_ID);
        if (!axnuiThemingProperty) {
            profileProperties.push({
                availablePropertyID: AXNUI_THEME_PROPERTY_TYPE_ID,
                id: null,
                value: JSON.stringify(DEFAULT_AXNUI_THEME)
            });
        }
        // if axnui layout property not present - add it
        const axnuiLayoutProperty = profile.profileProperties.find(pp => pp.availablePropertyID === AXNUI_LAYOUT_PROPERTY_TYPE_ID);
        if (!axnuiLayoutProperty) {
            profileProperties.push({
                availablePropertyID: AXNUI_LAYOUT_PROPERTY_TYPE_ID,
                id: null,
                value: JSON.stringify(DEFAULT_AXNUI_LAYOUT)
            });
        }
        // if axnui content property not present - add it
        const axnuiContentProperty = profile.profileProperties.find(pp => pp.availablePropertyID === AXNUI_CONTENT_PROPERTY_TYPE_ID);
        if (!axnuiContentProperty) {
            profileProperties.push({
                availablePropertyID: AXNUI_CONTENT_PROPERTY_TYPE_ID,
                id: null,
                //TODO - remove english constraint after migration
                value: JSON.stringify(DEFAULT_AXNUI_CONTENT[LocaleTypes.ENGLISH])
            });
        }
        // if dcui content property not present - add it
        const dcuiContentProperty = profileProperties.find(pp => pp.availablePropertyID === DCUI_CONTENT_PROPERTY_TYPE_ID);
        if (!dcuiContentProperty) {
            profileProperties.push({
                availablePropertyID: DCUI_CONTENT_PROPERTY_TYPE_ID,
                id: null,
                //TODO - remove english constraint after migration
                value: JSON.stringify(DEFAULT_DCUI_CONTENT[LocaleTypes.ENGLISH])
            });
        }
        // if dcui theme property not present - add it
        const dcuiThemeProperty = profileProperties.find(pp => pp.availablePropertyID === DCUI_THEME_PROPERTY_TYPE_ID);
        if (!dcuiThemeProperty) {
            profileProperties.push({
                availablePropertyID: DCUI_THEME_PROPERTY_TYPE_ID,
                id: null,
                value: JSON.stringify(DEFAULT_DCUI_THEME)
            });
        }
    }

    const company = axnCompanies.find(c => c.id === profile.companyID);
    const formattedProfileProperties = formatAppliedProfileProfileProperties(
        profileProperties,
        availableProperties
    );

    return {
        company: company,
        id: profile.id,
        name: profile.name,
        profileProperties: formattedProfileProperties
    };
};